import { ConstructionTreeComponent } from './ConstructionTreeComponent';

export default ConstructionTreeComponent;